<template>
    <div id="ctWrap" >
        <div class="spacer-50 pc-mode"></div>
        <div class="spacer-40 mb-mode"></div>
        <div class="login-top-box">
            <a href="" class="btn-logo"><img src="/img/common/logo.png"></a>
        </div>
        <div class="main-title">Reset password</div>
        <div class="spacer-30 pc-mode"></div>
        <div class="spacer-10 mb-mode"></div>
        <div class="login-middle-box">
            <p>E-Mail Address</p>
            <input type="text" name="emailAddress" id="emailAddress" class="form-control rpx-input-box" v-model="emailAddress">
            <div class="spacer-40"></div>
            <div class="m-btn">
                <a href="#" v-on:click="reset">Send Password Reset Link </a>
            </div>
        </div>
    </div>
</template>
<style>
    .login-middle-box {
        max-width: 800px;
    }
    .login-middle-box > .rpx-input-box {
        color:#fff!important;
        background-color:#5741d2 !important;
    }
</style>

<script>
import axios from 'axios'
export default {
    data: () =>{
        return {
            emailAddress: ''
        }
    },
    created() {
    },
    mounted() {
        $("#app").removeClass('main');
        $("#gnb").hide(); // 메인의 메인링크부분을 숨긴다.
    },
    methods:{
        reset:function(){
            if (!this.emailAddress) {
                alert("Please, Input Email-Address");
                return;
            }
            axios
                .post("/account/v1/fogot-password/email", {
                    email: this.emailAddress,
                })
                .then(response => {
                    if (response.status == 200) {
                        if (response.data.status == 'f') {
                            alert(response.data.message);
                            return;
                        }
                        alert("Password reset email was sent!")
                        this.$router.push('/');
                    }
                })
                .catch(error => {
                    console.log(error)
                    alert("Reset Password Failed: Please, Contact to administrator.");
                })
        }
    }
};
</script>
<style>
</style>
